import React, { useEffect, useRef, useState } from "react";

import "./stylesLiveSports.css";
import ClipPath from "../../../../assets/icons/ic_clip-path.svg";

import createPrivateAdminPanelInstance from "../../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../../api/ApiRoutes";

import AllSports from "./AllSports/AllSports";
import IndividualSport from "./IndividualSport/IndividualSport";

import Sortable from "sortablejs";
import { message } from "antd";
import { useQuery } from "@tanstack/react-query";

function LiveSports() {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const containerRef = useRef(null);
  const headerSortableRef = useRef(null);
  const hasFetchedRef = useRef(false);
  const [messageApi, contextHolder] = message.useMessage();

  const [apiIsRunning, setApiIsRunning] = useState(false);
  const [activeTab, setActiveTab] = useState("all-sports");
  const [liveSports, setLiveSports] = useState([]);

  const allSports = [{ id: "all-sports", name: "All Sports", order: 0 }];

  const [pinnedLeagues, setPinnedLeagues] = useState([]);

  const mockData = {
    id: "basketball-1",
    name: "Basketball",
    order: 1,
    status: true,
    countries: [
      {
        id: "basketball-usa-1",
        name: "USA",
        icon: "USA",
        order: 0,
        status: true,
        leagues: [
          {
            id: "basketball-usa-ncaa-1",
            name: "NCAA",
            order: 0,
            status: true,
          },
          { id: "basketball-usa-nba-1", name: "NBA", order: 1, status: true },
          {
            id: "basketball-usa-wnba-1",
            name: "WNBA",
            order: 2,
            status: true,
          },
        ],
      },
      {
        id: "basketball-canada-1",
        name: "Canada",
        icon: "Canada",
        order: 1,
        status: true,
        leagues: [
          {
            id: "basketball-canada-nba-1",
            name: "NBA",
            order: 0,
            status: true,
          },
          {
            id: "basketball-canada-wnba-1",
            name: "WNBA",
            order: 1,
            status: true,
          },
        ],
      },
      {
        id: "basketball-europe-1",
        name: "Europe",
        icon: "EUROPE",
        order: 2,
        status: true,
        leagues: [
          {
            id: "basketball-europe-nba-1",
            name: "NBA",
            order: 0,
            status: true,
          },
          {
            id: "basketball-europe-wnba-1",
            name: "WNBA",
            order: 1,
            status: true,
          },
        ],
      },
    ],
  };

  const handleSportClick = (id) => {
    setActiveTab(id);
  };

  const getLiveSports = async () => {
    try {
      setApiIsRunning(true);
      const requests = [
        PrivateAdminPanelInstance.post(API_ROUTES.GET_SPORTS_ORDERING, {
          entity_type: "LIVE",
        }),
        PrivateAdminPanelInstance.post(API_ROUTES.GET_ENTITIES_BY_TYPE, {
          entity_type: "LIVE",
          item_type: "COUNTRY",
          include_inactive: true,
        }),
        PrivateAdminPanelInstance.post(API_ROUTES.GET_ENTITIES_BY_TYPE, {
          entity_type: "LIVE",
          item_type: "LEAGUE",
          include_inactive: true,
        }),
      ];

      const responses = await Promise.allSettled(requests);

      const [liveSportsResponse, countriesResponse, leaguesResponse] =
        responses;

      let liveSportsData = [];
      let countriesData = [];
      let leaguesData = [];

      if (
        liveSportsResponse.status === "fulfilled" &&
        countriesResponse.status === "fulfilled" &&
        leaguesResponse.status === "fulfilled"
      ) {
        liveSportsData = liveSportsResponse.value.data.data.sports || [];
        countriesData = countriesResponse.value.data.data.entities || [];
        leaguesData = leaguesResponse.value.data.data.entities || [];

        const formattedLiveSportsData = liveSportsData.map((item) => {
          return {
            id: item.sport_id,
            name: item.name,
            order: item.display_order,
            status: item.is_active,
            is_pinned: item.is_pinned,
            countries: countriesData
              .filter((country) => country.parent_sport_id === item.sport_id)
              .map((country, index) => {
                // Normalize country identifiers so leagues with composite parent IDs are still matched.
                const countryCompositeId = `COUNTRY#${country.parent_sport_id}#${country.country_id}`;
                const candidateParentCountryIds = new Set([
                  country.country_id,
                  country.id,
                  countryCompositeId,
                ]);

                return {
                  id: `${country.parent_sport_id}#${country.country_id}`,
                  entity_id: country.entity_id,
                  country_id: country.country_id,
                  name: country.country_name,
                  icon: country.country_flag_url || country.icon || null,
                  order: index,
                  status: country.is_active,
                  leagues: leaguesData
                    .filter((league) => {
                      if (!league) return false;
                      if (league.country_id === country.country_id) {
                        return true;
                      }

                      const parentCountryId = league.parent_country_id;
                      if (!parentCountryId) {
                        return false;
                      }

                      if (candidateParentCountryIds.has(parentCountryId)) {
                        return true;
                      }

                      if (parentCountryId.startsWith("COUNTRY#")) {
                        return candidateParentCountryIds.has(
                          parentCountryId.replace(/^COUNTRY#/, "")
                        );
                      }

                      return false;
                    })
                    .map((league, index) => ({
                      id: league.entity_id,
                      reorder_id: league.entity_id.replace("LEAGUE#", ""),
                      name: league.name,
                      order: index,
                      status: league.is_active,
                    })),
                };
              }),
          };
        });
        const pinnedLeagues = leaguesData
          .filter((league) => league.is_pinned)
          .map((league, index) => ({
            id: league.entity_id,
            name: league.name,
            order: index,
            status: league.is_active,
            sport_id: league.sport_id,
          }));
        console.log("formattedLiveSportsData", formattedLiveSportsData);
        setLiveSports(formattedLiveSportsData);
        setPinnedLeagues(pinnedLeagues);
      }
    } catch (error) {
      console.log("error getting live sports", error);
    } finally {
      setApiIsRunning(false);
    }
  };

  const reorderEntities = async (
    itemType = "SPORT",
    orderedIds,
    parentId = null
  ) => {
    let params = {
      entity_type: "LIVE",
      item_type: "SPORT",
      ordered_ids: orderedIds,
    };

    if (itemType === "COUNTRY" || itemType === "LEAGUE") {
      params.parent_id = parentId;
      params.item_type = itemType;
    }

    try {
      setApiIsRunning(true);
      const res = await PrivateAdminPanelInstance.post(
        API_ROUTES.REORDER_ENTITIES,
        params
      );

      if (res.status !== 200) {
        throw new Error(`Status ${res.status}`);
      }

      return res.data;
    } catch (error) {
      console.log("error reordering sports", error);
      throw error;
    } finally {
      setApiIsRunning(false);
    }
  };

  useEffect(() => {
    if (!containerRef.current) return;

    if (headerSortableRef.current) {
      headerSortableRef.current.destroy();
      headerSortableRef.current = null;
    }

    headerSortableRef.current = Sortable.create(containerRef.current, {
      animation: 150,
      onEnd: (evt) => {
        setLiveSports((prevSports) => {
          if (!prevSports.length) return prevSports;

          const newOrder = [...prevSports];
          const [movedItem] = newOrder.splice(evt.oldIndex, 1);
          newOrder.splice(evt.newIndex, 0, movedItem);

          let orderCounter = 0;
          const updatedOrder = newOrder.map((item) => ({
            ...item,
            order: orderCounter++,
          }));

          const previousState = prevSports;

          (async () => {
            try {
              await reorderEntities(
                "SPORT",
                updatedOrder
                  .filter((sport) => sport.id !== "all-sports")
                  .map((sport) => sport.id),
                null
              );

              message.success("Order updated successfully!");
            } catch (err) {
              console.error("Error updating backend", err);
              setLiveSports(previousState);
              message.error("Error updating order. Please try again.");
            }
          })();

          return updatedOrder;
        });
      },
    });
    return () => {
      if (headerSortableRef.current) {
        headerSortableRef.current.destroy();
        headerSortableRef.current = null;
      }
    };
  }, []);

  // Fetching handled by react-query
  useQuery({
    queryKey: ["live-sports", "sports-countries-leagues"],
    queryFn: getLiveSports,
    refetchOnWindowFocus: false,
  });

  return (
    <div className={`live-sports-container`}>
      {contextHolder}

      <div className={`live-sports-body ${apiIsRunning ? "loading" : ""}`}>
        <div className="live-sports-body-header">
          <div
            key={"all-sports"}
            data-id={"all-sports"}
            data-order={0}
            onClick={() => handleSportClick("all-sports")}
            className={`live-sports-body-header-sport ${
              activeTab === "all-sports" ? "active" : ""
            }`}
          >
            <span>
              All Sports
            </span>
          </div>
          <div className="live-sports-body-header-sports" ref={containerRef}>
            {liveSports?.map((sport) => (
              <div
                key={sport.id}
                data-id={sport.id}
                data-order={sport.order}
                onClick={() => handleSportClick(sport.id)}
                className={`live-sports-body-header-sport ${
                  activeTab === sport.id ? "active" : ""
                }`}
              >
                <img src={ClipPath} alt="ClipPath" />
                <span>
                  {sport.name}
                </span>
              </div>
            ))}
          </div>
        </div>
        {activeTab === "all-sports" && (
          <AllSports
            liveSports={liveSports}
            setLiveSports={setLiveSports}
            containerRef={containerRef}
            reorderEntities={reorderEntities}
          />
        )}
        {activeTab !== "all-sports" && (
          <IndividualSport
            sport={liveSports.find((sport) => sport.id === activeTab)}
            liveSports={liveSports}
            setLiveSports={setLiveSports}
            activeTab={activeTab}
            pinnedLeagues={pinnedLeagues}
            setPinnedLeagues={setPinnedLeagues}
            reorderEntities={reorderEntities}
            setApiIsRunning={setApiIsRunning}
          />
        )}
      </div>
    </div>
  );
}

export default LiveSports;

